import React from "react";

function NotFound() {
  return <h2>NotFound</h2>
}

export default NotFound;
